import { render } from "./CreateWorkspace.vue?vue&type=template&id=babd7a84"
import script from "./CreateWorkspace.vue?vue&type=script&lang=js"
export * from "./CreateWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__